import React, { lazy } from 'react';
export function WhatIsSection() {
  return <section id="wat-is-het" className="py-16 lg:py-24 bg-white border-b border-slate-100 overflow-hidden" data-id="element-238">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-239">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-8 items-center" data-id="element-240">
          <div className="lg:col-span-5" data-id="element-241">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-slate-950 mb-6 tracking-tighter leading-tight" data-id="element-242">
              Wat is Meester djay?
            </h2>
            <p className="text-lg text-slate-600 leading-relaxed mb-10" data-id="element-243">
              Meester djay helpt leerlingen in groep 6, 7 en 8 om rekenen, taal,
              spelling en meer te oefenen op hun eigen niveau. Het platform past
              zich automatisch aan: wie iets goed begrijpt krijgt moeilijkere
              vragen, wie moeite heeft krijgt extra uitleg en visuele hulp.
            </p>

            <div className="flex flex-col gap-8" data-id="element-244">
              <div className="relative pl-6 border-l-4 border-orange-500 rounded-l-sm" data-id="element-245">
                <h3 className="text-xl font-bold text-slate-950 mb-2" data-id="element-246">
                  Adaptief leren
                </h3>
                <p className="text-slate-600 leading-relaxed" data-id="element-247">
                  Het systeem herkent wat een leerling al kan en wat nog niet.
                  Vragen worden automatisch moeilijker of makkelijker, zodat elk
                  kind op zijn eigen tempo groeit.
                </p>
              </div>

              <div className="relative pl-6 border-l-4 border-amber-400 rounded-l-sm" data-id="element-248">
                <h3 className="text-xl font-bold text-slate-950 mb-2" data-id="element-249">
                  Direct feedback
                </h3>
                <p className="text-slate-600 leading-relaxed" data-id="element-250">
                  Bij elk antwoord krijgt de leerling uitleg: niet alleen wát
                  het goede antwoord is, maar waaróm — inclusief specifieke
                  uitleg bij foute antwoorden.
                </p>
              </div>

              <div className="relative pl-6 border-l-4 border-emerald-400 rounded-l-sm" data-id="element-251">
                <h3 className="text-xl font-bold text-slate-950 mb-2" data-id="element-252">
                  Visuele ondersteuning
                </h3>
                <p className="text-slate-600 leading-relaxed" data-id="element-253">
                  Getallenlijnen, breukenbalken, klokken en meer maken abstracte
                  concepten concreet. Visuele hulp verschijnt precies wanneer
                  het nodig is.
                </p>
              </div>
            </div>
          </div>

          <div className="lg:col-span-6 lg:col-start-7 relative mt-12 lg:mt-0" data-id="element-254">
            {/* Background blob/glow */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] bg-orange-50/50 rounded-full blur-3xl -z-10" data-id="element-255" />

            <div className="relative h-[500px] sm:h-[600px] w-full" data-id="element-256">
              {/* Top screenshot - Tafel van 8 */}
              <div className="absolute top-0 right-0 w-[85%] rounded-2xl overflow-hidden shadow-2xl border border-slate-100 transform rotate-2 hover:rotate-0 transition-transform duration-500 z-20" data-id="element-257">
                <img src="https://cdn.magicpatterns.com/uploads/iDVrYsu6t9NcRYysfrAfD2/screencapture-demo-meesterdjay-nl-2026-04-01-09_55_55.png" alt="Oefening tafel van 8" className="w-full h-auto" loading="lazy" data-id="element-258" />
              </div>

              {/* Bottom screenshot - Cijferend rekenen */}
              <div className="absolute bottom-0 left-0 w-[85%] rounded-2xl overflow-hidden shadow-xl border border-slate-100 transform -rotate-3 hover:rotate-0 transition-transform duration-500 z-10" data-id="element-259">
                <img src="https://cdn.magicpatterns.com/uploads/es7MJELUZjbqhdWHWva461/screencapture-demo-meesterdjay-nl-2026-04-01-09_56_33.png" alt="Oefening cijferend rekenen" className="w-full h-auto" loading="lazy" data-id="element-260" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}